import { render } from "./redeem.vue?vue&type=template&id=3e39e864&scoped=true"
import script from "./redeem.vue?vue&type=script&lang=js"
export * from "./redeem.vue?vue&type=script&lang=js"

import "./redeem.vue?vue&type=style&index=0&id=3e39e864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e39e864"]])

export default __exports__